import { defineAsyncComponent } from 'vue';

export { useHelpStationStore } from './stores/helpStation';

export { useHelpStation } from './useHelpStation';

export { useVirtualAssistantStore } from './stores/virtualAssistant';

export * from './constants';

export const helpStationMicroFrontends = {
	HelpStation: defineAsyncComponent(
		() => import('./components/HelpStation.vue')
	),
	TrialGuideGetStartedButton: defineAsyncComponent(
		() => import('./components/TrialGuideGetStartedButton')
	),
	HelpStationHelpButton: defineAsyncComponent(
		() => import('./components/HelpStationHelpButton')
	),
};
